import TeaCup from '@/assets/images/svg/tea-cup.svg';
import { StateMessage } from '@/components/shared/state-message';

interface EmptyCoursesListProps {
  isCompleted?: boolean;
  onAction?: () => void;
}

export const EmptyCoursesList = ({
  isCompleted,
  onAction,
}: EmptyCoursesListProps) => {
  const title = `Você não tem nenhum curso ${isCompleted ? 'concluído' : 'em andamento'}`;
  const subtitle = isCompleted
    ? 'Assista um curso até concluir todo conteúdo.'
    : 'Explore as trilhas e comece a se desenvolver agora mesmo.';

  return (
    <StateMessage
      title={title}
      description={subtitle}
      image={TeaCup}
      action={{
        onClick: () => onAction?.(),
        label: 'Catálogo de cursos',
      }}
    />
  );
};
